(function () {
	'use strict';
	angular.module('app.core')
        .service('customFieldsFilters', customFieldsFilters);

	customFieldsFilters.$inject = ['URLS'];

	function customFieldsFilters(URLS) {
		var filters = {};
		var customFields = globalConfig.customer.customFields;
		customFields.forEach(function (field) {
			var fieldId = 'cus_' + field.ndx;
			var fieldName = field.name;
			var filterDefinition = {
				id: fieldId,
				displayName: fieldName,
				label: fieldName,
				authz: ['filters', 'leanProjects'],
				type: getFilterObjectByCustomFieldType(field.fieldType),
				dashboardEventName: 'CustomFields'
			};

			if (filterDefinition.type === 'multiselect') {
				filterDefinition.label = 'value';
				filterDefinition.comparisonKey = 'value';
				filterDefinition.url = String.format(URLS.getCustomFieldValues, globalConfig.customer.id, field.ndx);
				filterDefinition.staticOption = [{
					value: 'None',
					class: 'staticOption'
				}];
			}

			filters[fieldId] = filterDefinition;
		});
		return filters;
	}

	function getFilterObjectByCustomFieldType(customFieldType) {
		switch (customFieldType) {
		case 'TEXT':
		case 'TEXTAREA':
			return 'string';
		case 'DROPDOWN':
			return 'multiselect';
		case 'NUMBER':
		case 'CURRENCY':
			return 'numerical';
		case 'DATE':
			return 'date';
		}
	}
})();
